import { CALCULATOR_SCREENING } from "./federal-calculator.ts";

export const INVESTMENT_CALCULATOR_VERSION =
  "ZT-TY2025-INVESTMENT-CALCULATOR-1";
export const INVESTMENT_PROFILE = "TY2025_W2_INTEREST_DIVIDENDS_1";
export const INVESTMENT_SCREENING = CALCULATOR_SCREENING.map((s) =>
  s.id === "income"
    ? {
        ...s,
        label: "Wages, interest and dividends only",
        detail:
          "All income consists of the W-2, 1099-INT and 1099-DIV statements entered here. No sales, losses, loss carryovers, retirement distributions, business, rental, tips, qualified overtime or other income. Capital gain distributions may come only from 1099-DIV box 2a.",
      }
    : s.id === "payments"
      ? {
          ...s,
          label: "Statement withholding is the only payment",
          detail:
            "Include withholding from every W-2, 1099-INT and 1099-DIV. No estimates, extension payments, prior-year credits or other payments. Any refund is requested in full.",
        }
      : s,
);
export const INVESTMENT_CONFIRMATIONS = [
  {
    id: "sourceReview",
    label: "All statement fields have been checked",
    detail:
      "I compared all boxes, tax year, payer, recipient and correction status with the final source statements. These are manual confirmed entries, not automatically extracted amounts.",
  },
  {
    id: "ownership",
    label: "The income belongs to this taxpayer",
    detail:
      "No nominee distributions, joint ownership allocation, foreign-source income, foreign accounts, foreign trusts or foreign-entity reporting.",
  },
  {
    id: "interestTreatment",
    label: "No special interest adjustments",
    detail:
      "No seller-financed mortgage, accrued bond interest, original issue discount, market discount election, unreported interest, savings-bond exclusion or bond-premium adjustment outside the entered statements.",
  },
  {
    id: "dividendTreatment",
    label: "Qualified dividends and distributions reviewed",
    detail:
      "The eligible qualified amount has been checked for holding period and other qualification requirements. No investment-interest election, foreign-tax election, capital-loss carryover, extraordinary distribution, basis adjustment or Schedule D transaction.",
  },
] as const;
export const INTEREST_BOXES = [
  ["box1", "Box 1 — Interest income"],
  ["box2", "Box 2 — Early withdrawal penalty"],
  ["box3", "Box 3 — U.S. savings bonds and Treasury interest"],
  ["box4", "Box 4 — Federal tax withheld"],
  ["box5", "Box 5 — Investment expenses"],
  ["box6", "Box 6 — Foreign tax paid"],
  ["box8", "Box 8 — Tax-exempt interest"],
  ["box9", "Box 9 — Specified private activity bond interest"],
  ["box10", "Box 10 — Market discount"],
  ["box11", "Box 11 — Bond premium"],
  ["box12", "Box 12 — Treasury bond premium"],
  ["box13", "Box 13 — Tax-exempt bond premium"],
] as const;
export const DIVIDEND_BOXES = [
  ["box1a", "Box 1a — Total ordinary dividends"],
  ["box1b", "Box 1b — Reported qualified dividends"],
  ["eligibleQualified", "Eligible qualified dividends after review"],
  ["box2a", "Box 2a — Total capital gain distributions"],
  ["box2b", "Box 2b — Unrecaptured section 1250 gain"],
  ["box2c", "Box 2c — Section 1202 gain"],
  ["box2d", "Box 2d — Collectibles gain"],
  ["box2e", "Box 2e — Section 897 ordinary dividends"],
  ["box2f", "Box 2f — Section 897 capital gain"],
  ["box3", "Box 3 — Nondividend distributions"],
  ["box4", "Box 4 — Federal tax withheld"],
  ["box5", "Box 5 — Section 199A dividends"],
  ["box6", "Box 6 — Investment expenses"],
  ["box7", "Box 7 — Foreign tax paid"],
  ["box9", "Box 9 — Cash liquidation distributions"],
  ["box10", "Box 10 — Noncash liquidation distributions"],
  ["box12", "Box 12 — Exempt-interest dividends"],
  ["box13", "Box 13 — Specified private activity bond dividends"],
] as const;
export const INVESTMENT_NOTICE =
  "Calculation from explicitly reviewed statement entries. Not a certified, signed or filing-ready return. Non-W-2 OCR has not been activated by entering these amounts.";
